
export class CreateMasterColMappingsRequest {
    orgID: number;

    constructor(orgID: number) {
      this.orgID = orgID;
    }
}
